module.exports = __webpack_public_path__ + "static/media/Ijs.086253e2.svg";